// @mui
import { Container, Grid } from '@mui/material';

import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores/store';

//Localization
import useLocales from 'src/hooks/useLocales';
import Page from 'src/components/Page';
import useSettings from 'src/hooks/useSettings';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { PATH_DASHBOARD } from 'src/routes/paths';
import ElectricBoxDetailTableRow from './ElectricBoxDetailTableRow';
import Loader from 'src/components/loader/Loader';
import { useState, useEffect } from 'react';
// ----------------------------------------------------------------------
export default observer(function ElectricBoxDetailHeader() {
  const { translate } = useLocales();
  const {
    ElectricBoxStore: { selectedElectricBoxDetail, clearSelectedElectricBox, ID, loadElectricBoxDetail },
  } = useStore();

  const [isLoading, setIsLoading] = useState(true); // Track loading state

  useEffect(() => {
    if (ID) {
      setIsLoading(true);
      loadElectricBoxDetail(ID).finally(() => setIsLoading(false)); // Ensure loading ends
    }
  }, [loadElectricBoxDetail, ID]);

  const { themeStretch } = useSettings();

  // Handle case when no ID or data is available
  if (!ID) {
    return (
      <Page title={translate('ElectricBox.ElectricBoxDetails')}>
        <Container maxWidth={themeStretch ? false : 'lg'}>
          <HeaderBreadcrumbs
            heading={translate('ElectricBox.ElectricBoxDetails')}
            links={[
              { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
              {
                name: `${translate('ElectricBox.ElectricBox')}`,
                href: PATH_DASHBOARD.ElectricBox.list,
              },
            ]}
          />
          <p>{translate('ElectricBox.NoData')}</p>
        </Container>
      </Page>
    );
  }

  return (
    <Page title={translate('ElectricBox.ElectricBoxDetails')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('ElectricBox.ElectricBoxDetails')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('ElectricBox.ElectricBox')}`,
              href: PATH_DASHBOARD.ElectricBox.list,
            },
          ]}
        />
        {isLoading ? ( // Show loading state
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
          
            <Loader /> {/* Replace with Loader */}
          </Grid>
        ) : selectedElectricBoxDetail ? ( // Render details if available
          <Grid container>
            <ElectricBoxDetailTableRow
              row={selectedElectricBoxDetail}
              clearElectricBox={clearSelectedElectricBox}
            />
          </Grid>
        ) : (
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <p>{translate('ElectricBox.NoData')}</p>
          </Grid>
        )}
      </Container>
    </Page>
  );
});
